import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const BoardPowerUpsContextDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BoardPowerUpsContext"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preferredLocales"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"plugins"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"EnumValue","value":"private"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"categories"}},{"kind":"Field","name":{"kind":"Name","value":"deprecation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"infoLink"}},{"kind":"Field","name":{"kind":"Name","value":"sunsetDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"heroImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"idOrganizationOwner"}},{"kind":"Field","name":{"kind":"Name","value":"iframeConnectorUrl"}},{"kind":"Field","name":{"kind":"Name","value":"isCompliantWithPrivacyStandards"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"overview"}}]}},{"kind":"Field","name":{"kind":"Name","value":"moderatedState"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"privacyUrl"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"supportEmail"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"usageBrackets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boards"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"publicPlugins"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"preferredLocales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preferredLocales"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"categories"}},{"kind":"Field","name":{"kind":"Name","value":"deprecation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"infoLink"}},{"kind":"Field","name":{"kind":"Name","value":"sunsetDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"heroImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"idOrganizationOwner"}},{"kind":"Field","name":{"kind":"Name","value":"iframeConnectorUrl"}},{"kind":"Field","name":{"kind":"Name","value":"isCompliantWithPrivacyStandards"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"overview"}}]}},{"kind":"Field","name":{"kind":"Name","value":"moderatedState"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"privacyUrl"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"supportEmail"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"usageBrackets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boards"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"BoardPowerUpsContext","document":BoardPowerUpsContextDocument}} as const;
export type BoardPowerUpsContextQueryVariables = Types.Exact<{
  boardId: Types.Scalars['ID']['input'];
  preferredLocales: Types.Scalars['String']['input'];
}>;


export type BoardPowerUpsContextQuery = (
  { __typename: 'Query' }
  & { board?: Types.Maybe<(
    { __typename: 'Board' }
    & Pick<Types.Board, 'id'>
    & { plugins: Array<(
      { __typename: 'Plugin' }
      & Pick<Types.Plugin, 'id' | 'author' | 'categories' | 'email' | 'heroImageUrl' | 'idOrganizationOwner' | 'iframeConnectorUrl' | 'isCompliantWithPrivacyStandards' | 'moderatedState' | 'name' | 'privacyUrl' | 'public' | 'supportEmail' | 'tags'>
      & { deprecation?: Types.Maybe<(
        { __typename: 'Plugin_Deprecation' }
        & Pick<Types.Plugin_Deprecation, 'infoLink' | 'sunsetDate'>
      )>, icon: (
        { __typename: 'Plugin_Icon' }
        & Pick<Types.Plugin_Icon, 'url'>
      ), listing?: Types.Maybe<(
        { __typename: 'Plugin_Listing' }
        & Pick<Types.Plugin_Listing, 'description' | 'name' | 'overview'>
      )>, usageBrackets: (
        { __typename: 'Plugin_UsageBrackets' }
        & Pick<Types.Plugin_UsageBrackets, 'boards'>
      ) }
    )> }
  )>, publicPlugins: Array<(
    { __typename: 'Plugin' }
    & Pick<Types.Plugin, 'id' | 'author' | 'categories' | 'email' | 'heroImageUrl' | 'idOrganizationOwner' | 'iframeConnectorUrl' | 'isCompliantWithPrivacyStandards' | 'moderatedState' | 'name' | 'privacyUrl' | 'public' | 'supportEmail' | 'tags'>
    & { deprecation?: Types.Maybe<(
      { __typename: 'Plugin_Deprecation' }
      & Pick<Types.Plugin_Deprecation, 'infoLink' | 'sunsetDate'>
    )>, icon: (
      { __typename: 'Plugin_Icon' }
      & Pick<Types.Plugin_Icon, 'url'>
    ), listing?: Types.Maybe<(
      { __typename: 'Plugin_Listing' }
      & Pick<Types.Plugin_Listing, 'description' | 'name' | 'overview'>
    )>, usageBrackets: (
      { __typename: 'Plugin_UsageBrackets' }
      & Pick<Types.Plugin_UsageBrackets, 'boards'>
    ) }
  )> }
);

/**
 * __useBoardPowerUpsContextQuery__
 *
 * To run a query within a React component, call `useBoardPowerUpsContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useBoardPowerUpsContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBoardPowerUpsContextQuery({
 *   variables: {
 *      boardId: // value for 'boardId'
 *      preferredLocales: // value for 'preferredLocales'
 *   },
 * });
 */
export function useBoardPowerUpsContextQuery(
  baseOptions: TrelloQueryHookOptions<
    BoardPowerUpsContextQuery,
    BoardPowerUpsContextQueryVariables
  >,
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: BoardPowerUpsContextDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    BoardPowerUpsContextQuery,
    BoardPowerUpsContextQueryVariables
  >(BoardPowerUpsContextDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useBoardPowerUpsContextLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    BoardPowerUpsContextQuery,
    BoardPowerUpsContextQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BoardPowerUpsContextQuery,
    BoardPowerUpsContextQueryVariables
  >(BoardPowerUpsContextDocument, options);
}
export type BoardPowerUpsContextQueryHookResult = ReturnType<
  typeof useBoardPowerUpsContextQuery
>;
export type BoardPowerUpsContextLazyQueryHookResult = ReturnType<
  typeof useBoardPowerUpsContextLazyQuery
>;
export type BoardPowerUpsContextQueryResult = Apollo.QueryResult<
  BoardPowerUpsContextQuery,
  BoardPowerUpsContextQueryVariables
>;
